<body class="ubimax-error-page ubimax-login-page theme-default container-fluid">
<div class="body-gradient-background">
    <div class="mainbox">
        <div *ngIf="status !== '-1'" class="err" id="code">{{status}}</div>
        <div class="msg" (click)="this.clickable ? redirectToLogin() : ''" [innerHTML]="message"></div>
    </div>
</div>
</body>
